import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const PARTNER_TYPES_SAVED = gql`
  subscription partnerTypesSaved {
    partnerTypesSaved {
      partnerTypes {
        id
        code
        name
        baseTypes {
          id
          code
          name
          isSelected
        }
        properties {
          partnerTypeId
          propertyId
          propertyName
          propertyTypeCode
          defaultValue
          mandatory
        }
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const PARTNER_TYPE_DELETED = gql`
  subscription partnerTypeDeleted {
    partnerTypeDeleted {
      id
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
